import { FC, useMemo } from 'react';
import { TransactionHistoryItem } from '../../../../../atoms/wallet/transactionHistoryAtom';
import Logo from '../../../Logo';
import Typography from '../../../Typography';
import Icon from '../../../Icon';
import Link from '../../../Link';
import { TransactionHistoryItemType } from '../../../../../interfaces';
import { IconVariant } from '../../../Icon/Icon';

import './WalletPopupTransaction.scss';
import TooltipWrapper from '../../../TooltipWrapper';

const transactionTypeToIcon: { [txType in TransactionHistoryItemType]: IconVariant } = {
  DEPOSIT: 'transaction-deposit-and-stake',
  STAKE: 'transaction-deposit-and-stake',
  WITHDRAW: 'transaction-withdraw-and-unstake',
  UNSTAKE: 'transaction-withdraw-and-unstake',
  SWAP: 'transaction-swap',
  ADJUST: 'transaction-adjust',
  BORROW: 'transaction-borrow',
  REPAY: 'transaction-repay',
  BRIDGE: 'transaction-bridge',
};

interface WalletPopupTransactionProps {
  transaction: TransactionHistoryItem;
}

const WalletPopupTransaction: FC<WalletPopupTransactionProps> = ({ transaction }) => {
  const transactionTokens = useMemo(() => {
    if (transaction.externalTokens && transaction.externalTokens.length > 1) {
      return (
        <>
          <div className="nostra__walletPopupTransaction__logoLeft">
            <img
              src={transaction.externalTokens[0]}
              key={transaction.externalTokens[0]}
              onError={e => {
                e.currentTarget.style.display = 'none';
              }}
            />
          </div>
          <div className="nostra__walletPopupTransaction__logoRight">
            <img
              src={transaction.externalTokens[1]}
              key={transaction.externalTokens[1]}
              onError={e => {
                e.currentTarget.style.display = 'none';
              }}
            />
          </div>
        </>
      );
    }
    if (transaction.externalTokens && transaction.externalTokens.length === 1) {
      return (
        <img
          src={transaction.externalTokens[0]}
          key={transaction.externalTokens[0]}
          onError={e => {
            e.currentTarget.style.display = 'none';
          }}
        />
      );
    }

    if (transaction.tokens && transaction.tokens.length > 1) {
      return (
        <>
          <div className="nostra__walletPopupTransaction__logoLeft">
            <Logo key={`token-${transaction.tokens[0]}`} type={`token-${transaction.tokens[0]}`} size={32} />
          </div>
          <div className="nostra__walletPopupTransaction__logoRight">
            <Logo key={`token-${transaction.tokens[1]}`} type={`token-${transaction.tokens[1]}`} size={32} />
          </div>
        </>
      );
    }
    if (transaction.tokens && transaction.tokens.length === 1) {
      return <Logo key={`token-${transaction.tokens[0]}`} type={`token-${transaction.tokens[0]}`} size={32} />;
    }
  }, [transaction.externalTokens, transaction.tokens]);

  return (
    <div className="nostra__walletPopupTransaction">
      <div className="nostra__walletPopupTransaction__info">
        <div className="nostra__walletPopupTransaction__logos">
          {transactionTokens}
          <div className="nostra__walletPopupTransaction__icon">
            <Icon variant={transactionTypeToIcon[transaction.type]} size={14} color="--icon-supporting" />
          </div>
        </div>
        <Typography variant="body-md">{transaction.message}</Typography>
      </div>
      {transaction.txHash && (
        <Link href={`https://voyager.online/tx/${transaction.txHash}`}>
          <Icon variant="external-link" size={16} color="--icon-supporting" />
        </Link>
      )}
      {transaction.txnExplorerUrls && (
        <TooltipWrapper
          placement="bottom"
          openEvent="mouseenter"
          tooltipContent={
            <div className="nostra__tooltipBox nostra__walletPopupTransaction__tooltipBox">
              {transaction.txnExplorerUrls.map(url => (
                <div key={url.url} className="nostra__walletPopupTransaction__tooltipBox__item">
                  <Typography variant="body-sm" color="text-primary-darkbg">
                    {url.label}
                  </Typography>
                  <Link href={url.url}>
                    <Icon variant="external-link" size={16} color="--icon-supporting" />
                  </Link>
                </div>
              ))}
            </div>
          }
        >
          <Icon variant="menu" size={16} color="--icon-supporting" />
        </TooltipWrapper>
      )}
    </div>
  );
};
export default WalletPopupTransaction;
